import styled from 'styled-components';

const FormulaName = styled.div`
  padding: 16px;
  text-align: center;
  border-radius: 8px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: #ffffff;

  ${p => p.background && `
    background-color: ${p.background};
  `}

  ${p => p.padding && `
    padding: ${p.padding};
  `}

  ${p => p.color && `
    color: ${p.color};
  `}
`;

export default FormulaName;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/components/formula-name.js